"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCreatePasswordBasedImapAccountArgs = void 0;
var HxServerInfoDataArgs_1 = require("./HxServerInfoDataArgs");
var HxServerPasswordAuthInfoDataArgs_1 = require("./HxServerPasswordAuthInfoDataArgs");
function serializeHxCreatePasswordBasedImapAccountArgs(_arg) {
    var output = [];
    output.push(_arg.displayName);
    output.push(_arg.userDisplayName);
    output.push(_arg.emailAddress);
    output.push(HxServerInfoDataArgs_1.serializeHxServerInfoDataArgs(_arg.incomingServerInfo));
    output.push(HxServerPasswordAuthInfoDataArgs_1.serializeHxServerPasswordAuthInfoDataArgs(_arg.incomingServerAuthInfo));
    output.push(HxServerInfoDataArgs_1.serializeHxServerInfoDataArgs(_arg.outgoingServerInfo));
    output.push(HxServerPasswordAuthInfoDataArgs_1.serializeHxServerPasswordAuthInfoDataArgs(_arg.outgoingServerAuthInfo));
    output.push(_arg.sslCertificateValidation !== undefined);
    if (_arg.sslCertificateValidation !== undefined) {
        output.push(_arg.sslCertificateValidation);
    }
    return output;
}
exports.serializeHxCreatePasswordBasedImapAccountArgs = serializeHxCreatePasswordBasedImapAccountArgs;
